import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import "../containers/MainAppContainer.css";
import { translations } from "../containers/assets/translations";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCar,
  faUser,
  faPrint,
  faEdit,
  faBan,
  faHistory,
  faShip,
  faBroom,
  faClipboardCheck,
  faSyncAlt,
  faPencilAlt,
  faTrashAlt,
  faChartLine,
  faFilePdf
} from "@fortawesome/free-solid-svg-icons";

export default class Menu extends Component {
  render() {
    return (
      <div className="col-md-12 menuContainer ">
        <Row>
          <Col md={12} xs={12}>
            <FontAwesomeIcon className="icon" icon={faUser} />
            <span className="floatLeft Menudescr">Boarding Passes Printed:</span>
            <span className="floatLeft TripData">
              {this.props.personBoardingPassesIssued}
            </span>
            <br />
            <span className="floatLeft Menudescr">Boarded/Remaining</span>
            <span className="floatLeft TripData">
              {this.props.checkedInPassengers}
            </span>
          </Col>
          <Col md={12} xs={12}>
            <FontAwesomeIcon className="icon" icon={faCar} />
            <span className="floatLeft Menudescr">Boarding Passes Printed:</span>
            <span className="floatLeft TripData">
              {this.props.vehicleBoardingPassesIssued}
            </span>
            <br />
            <span className="floatLeft Menudescr">Boarded/Remaining</span>
            <span className="floatLeft TripData">
              {this.props.checkedInVehicles}
            </span>
          </Col>
          <Col md={12} xs={12}>
            <FontAwesomeIcon className="icon" icon={faClipboardCheck} />
            <span className="floatLeft Menudescr">
              Confirmed passenger Tickets:
            </span>
            <span className="floatLeft TripData">
              {this.props.confirmedPassengers !== " undefined / undefined"? this.props.confirmedPassengers : ""}
            </span>
            <br />
            <span className="floatLeft Menudescr">
              Confirmed Vehicle Tickets:
            </span>
            <span className="floatLeft TripData">
              {this.props.confirmedVehicles !== " undefined / undefined"? this.props.confirmedVehicles : ""}
            </span>
          </Col>
        </Row>
        <Col md={12} className="d-flex flex-wrap justify-content-md-start justify-content-evenly">
          <Col
            md={4}
            sm={4}
            xs={4}
            className="optionMenu center "
            onClick={() => this.props.onClickPrintButton(true)}
          >
            <FontAwesomeIcon className="iconButton" icon={faPrint} />

            <div className="ButtonDescr">Print</div>
          </Col>
          <Col
            md={4}
            sm={4}
            xs={4}
            className="optionMenu center "
            onClick={() => this.props.onClickPrintButton(false)}
          >
            <FontAwesomeIcon className="iconButton" icon={faFilePdf} />

            <div className="ButtonDescr">PDF print</div>
          </Col>
          <Col
            md={4}
            sm={4}
            xs={4}
            className="optionMenu center "
            onClick={this.props.onClickEditTicketButton}
          >
            <FontAwesomeIcon className="iconButton" icon={faEdit} />
            <div className="ButtonDescr">Edit</div>
          </Col>
          <Col
            md={4}
            sm={4}
            xs={4}
            className="optionMenu center "
            onClick={this.props.onClickClearButton}
          >
            <FontAwesomeIcon className="iconButton" icon={faBroom} />
            <div className="ButtonDescr">Clear</div>
          </Col>
          <Col
            md={4}
            sm={4}
            xs={4}
            className="optionMenu center "
            onClick={this.props.onClickCancelButton}
          >
            <FontAwesomeIcon className="iconButton" icon={faBan} />
            <div className="ButtonDescr">Cancel</div>
          </Col>
          <Col
            md={4}
            sm={4}
            xs={4}
            className="optionMenu center "
            onClick={this.props.onClickHistoryButton}
          >
            <FontAwesomeIcon className="iconButton" icon={faHistory} />
            <div className="ButtonDescr">History</div>
          </Col>
          <Col
            md={4}
            sm={4}
            xs={4}
            className="optionMenu center "
            onClick={this.props.onClickReloadRoutesButton}
          >
            <FontAwesomeIcon className="iconButton" icon={faSyncAlt} />
            <div className="ButtonDescr">Reload Routes</div>
          </Col>
          <Col
            md={4}
            sm={4}
            xs={4}
            className="optionMenu center "
            onClick={this.props.lockTrip}
          >
            <FontAwesomeIcon className="iconButton" icon={faShip} />
            <div className="ButtonDescr">Lock/Unlock Trips</div>
          </Col>
          <Col
            md={4}
            sm={4}
            xs={4}
            className="optionMenu center "
            onClick={this.props.onClickManualEntryButton}
          >
            <FontAwesomeIcon className="iconButton" icon={faPencilAlt} />
            <div className="ButtonDescr">Manual Entry</div>
          </Col>
          <Col
            md={4}
            sm={4}
            xs={4}
            className="optionMenu center "
            onClick={this.props.deleteBooking}
          >
            <FontAwesomeIcon className="iconButton" icon={faTrashAlt} />
            <div className="ButtonDescr">Delete Booking</div>
          </Col>
          <Col
            md={4}
            sm={4}
            xs={4}
            className="optionMenu center "
            onClick={this.props.onClickReportsButton}
          >
            <FontAwesomeIcon className="iconButton" icon={faChartLine} />
            <div className="ButtonDescr">Reports</div>
          </Col>
          <Col
            md={4}
            sm={4}
            xs={4}
            className="optionMenu center "
            onClick={this.props.onClickPrintSelection}
          >
            <FontAwesomeIcon className="iconButton" icon={faPrint} />
            <div className="ButtonDescr">
              {translations[this.props.lang]["Printer Settings"]}{"\t\t\t\t"}
            </div>
          </Col>
        </Col>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu.js